import { getters } from '../utils'

export default (isImmediate = true, doRedirectToLogin = false) => ({
  computed: getters('authRedirect'),
  watch: {
    isAuth: {
      immediate: isImmediate,
      handler(isAuth) {
        if (!isAuth) {
          if (!doRedirectToLogin) return
          this.$router.push({ name: 'Login' })
        }

        this.$router.push({ name: this.authRedirect })
      },
    },
  },
})
